import { BaseService } from '../../infra/base.service'
import type { Person } from './person'
import type { PersonsRepository } from './persons.repository'

export class PersonsService extends BaseService<Person> {
    constructor(private personRep: PersonsRepository) {
        super(personRep)
    }

    async reactivate(personId: string) {
        return await this.personRep.reactivate(personId)
    }

    async Birthdays(from: Date, to: Date) {
        return this.personRep.Birthdays(from, to)
    }

    async LoginByLink(personId: string) {
        return await this.personRep.LoginByLink(personId)
    }

    async search(query: string, limit: number = 100) {
        return await this.personRep.search(query, limit)
    }

    async getRecents(recents: number) {
        return await this.personRep.getRecents(recents)
    }
}
